import { render, staticRenderFns } from "./UsersByRole.vue?vue&type=template&id=60604fe2&"
import script from "./UsersByRole.vue?vue&type=script&lang=js&"
export * from "./UsersByRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports